<div  style="width: 100%;" [formGroup]="group">
  <mat-checkbox [formControlName]="field.name">{{field.label}}</mat-checkbox>
</div>
